import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "20",
  height: "20",
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      "clip-rule": "evenodd",
      d: "M1.667 3.753a2 2 0 0 1 2-2h12.666a2 2 0 0 1 2 2V16.42a2 2 0 0 1-2 2H3.667a2 2 0 0 1-2-2V3.753z",
      stroke: "currentColor",
      "stroke-opacity": ".87",
      "stroke-width": "1.2"
    }, null, -1),
    _createElementVNode("path", {
      d: "M8.878 7.003h1.466v6.417H9.126L5.926 9.524v3.896H4.46V7.003h1.229l3.19 3.896V7.003zM13.293 8.415c1.503 0 2.374.696 2.374 2.19v2.815h-1.338v-.615c-.266.45-.78.688-1.504.688-1.155 0-1.842-.642-1.842-1.494 0-.871.614-1.476 2.117-1.476h1.137c0-.614-.367-.972-1.137-.972-.522 0-1.063.174-1.42.459l-.514-1c.54-.385 1.338-.595 2.127-.595zm-.11 4.115c.476 0 .889-.22 1.054-.669v-.504h-.981c-.67 0-.88.248-.88.578 0 .357.303.595.807.595z",
      fill: "currentColor",
      "fill-opacity": ".87"
    }, null, -1)
  ])))
}
export default { render: render }